.container {
    padding: 2rem;
    width: 100%;
    background-color: var(--static-background-standard);
    border-radius: 12px;
}

.loadingContainer {
   padding: 1rem;
   width: 100%;
   background-color: var(--static-background-standard);
   border-radius: 12px;
}

.grid {
    /*display: grid;*/
    /*grid-template-columns: 1fr 3fr;*/
    /*gap: 1.5rem;*/
    display: flex;
}

.statsColumn {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.metricGroup {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.labelGroup {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.dot {
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 9999px;
}

.dotRevenue {
    background-color: #F97316;
}

.dotFees {
    background-color: #EAB308;
}

.dotProfit {
    background-color: #2563EB;
}

.label {
    color: var(--static-text-strong);
    font-size: 14px;
    line-height: 20px
}

.value {
    font-size: 2rem;
    line-height: 40px;
    font-weight: 500;
    color: var(--static-text-strong);
}

.change {
    font-size: 0.75rem;
    line-height: 1rem;
    /*color: #16A34A;*/
    font-weight: 400;
    color: var(--static-text-weak)
}

.chartContainer {
    /*height: 20rem;*/
    width: 100%;
    transform: translateY(20px);
}

.tooltip {
    background-color: var(--static-background-standard);
    padding: 1rem;
    border-radius: 0.5rem;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
    border: 1px solid var(--static-divider-standard);
}

.tooltipDay {
    color: #4B5563;
    font-size: 0.875rem;
    line-height: 1.25rem;
    margin-bottom: 0.5rem;
}

.tooltipValue {
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 500;
}

.tooltipRevenue {
    color: var(--primary-enabled);
}

.tooltipFees {
    color: #F3D047;
}

.tooltipProfit {
    color: #5823FF;
}